<template>
  <aside :aria-label="$t('navigation.aria.promotionalBanner')" role="complementary">
    <GlobalUspBanner v-if="globalBannerType === 'uspBanner'" />
    <GlobalMarketingBanner v-else-if="globalBannerType === 'marketingBanner'" />
    <GlobalCountdownBanner v-else-if="globalBannerType === 'countdownBanner'" />
  </aside>
</template>

<script setup>
import { computed } from 'vue';
import { useGlobalBannerStore } from '@/stores/global-banner';
import GlobalUspBanner from './GlobalUspBanner.vue';
import GlobalMarketingBanner from './GlobalMarketingBanner.vue';
import GlobalCountdownBanner from './GlobalCountdownBanner.vue';

const globalBannerStore = useGlobalBannerStore();

const globalBannerType = computed(() => {
  if (globalBannerStore.globalBannerType) {
    return globalBannerStore.globalBannerType;
  }

  if (globalBannerStore.showUsps) {
    return 'uspBanner';
  }

  return 'marketingBanner';
});
</script>
